import { BillsTableActionsCell } from '../elements/BillsTableActionsCell'
import { BillsTableAmountCell } from '../elements/BillsTableAmountCell'
import { BillsTableAttachmentCell } from '../elements/BillsTableAttachmentCell'
import { BillsTableBillStatusCell } from '../elements/BillsTableBillStatusCell'
import { BillsTableDescriptionCell } from '../elements/BillsTableDescriptionCell'
import { BillsTableDueDateCell } from '../elements/BillsTableDueDateCell'
import { BillsTableEInvoiceStatusCell } from '../elements/BillsTableEInvoiceStatusCell'
import { BillsTableReceiptDateCell } from '../elements/BillsTableReceiptDateCell'
import { BillsTableReferenceCell } from '../elements/BillsTableReferenceCell'
import { BillsTableSupplierCell } from '../elements/BillsTableSupplierCell'
import { BillsTableSyncStatusCell } from '../elements/BillsTableSyncStatusCell'
import { BillsTableTypeCell } from '../elements/BillsTableTypeCell'
import { BillsTableColumn } from '../types/billsTableColumn'
import { billsTableColumnHeaderLocaleKeys } from './billsTableColumnHeaderLocaleKeys'

export const billsTableColumnDefinitions = [
  {
    key: 'billStatus',
    header: billsTableColumnHeaderLocaleKeys.billStatus,
    cell: (row) => <BillsTableBillStatusCell row={row} />,
  },
  {
    key: 'syncStatus',
    header: billsTableColumnHeaderLocaleKeys.syncStatus,
    cell: (row) => <BillsTableSyncStatusCell row={row} />,
  },
  {
    key: 'eInvoiceStatus',
    header: billsTableColumnHeaderLocaleKeys.eInvoiceStatus,
    cell: (row) => <BillsTableEInvoiceStatusCell row={row} />,
  },
  {
    key: 'syncStatusIcon',
    header: null,
    cell: (row) => <BillsTableSyncStatusCell row={row} isIconOnly />,
    type: 'action',
  },
  {
    key: 'reference',
    header: billsTableColumnHeaderLocaleKeys.reference,
    cell: (row) => <BillsTableReferenceCell row={row} />,
  },
  {
    key: 'supplier',
    header: billsTableColumnHeaderLocaleKeys.supplier,
    cell: (row) => <BillsTableSupplierCell row={row} />,
  },
  {
    key: 'receiptDate',
    header: billsTableColumnHeaderLocaleKeys.receiptDate,
    sortable: true,
    cell: (row) => <BillsTableReceiptDateCell row={row} />,
  },
  {
    key: 'dueDate',
    header: billsTableColumnHeaderLocaleKeys.dueDate,
    sortable: true,
    cell: (row) => <BillsTableDueDateCell row={row} />,
  },
  {
    key: 'description',
    header: billsTableColumnHeaderLocaleKeys.description,
    cell: (row) => <BillsTableDescriptionCell row={row} />,
  },
  {
    key: 'type',
    header: billsTableColumnHeaderLocaleKeys.type,
    cell: (row) => <BillsTableTypeCell row={row} />,
  },
  {
    key: 'amountTotal',
    header: billsTableColumnHeaderLocaleKeys.amountTotal,
    cell: (row) => <BillsTableAmountCell row={row} />,
  },
  {
    key: 'hasAttachments',
    header: null,
    cell: (row) => <BillsTableAttachmentCell row={row} />,
    type: 'action',
  },
  {
    key: 'actions',
    header: null,
    cell: (row) => <BillsTableActionsCell row={row} />,
    type: 'action',
  },
] as const satisfies readonly BillsTableColumn[]
